import {
  isDEV,
  jy_request, jy_request_common
} from '@/utils/request';
import {jy_tip} from '@/utils/vue.tool';
//base64，js原生方法btoa()实现
export const token_key = 'access-token';
export const product = 'BioinfoGPT';
export function b64EncodeUnicode(str) {
  return btoa(encodeURIComponent(str).replace(/%([0-9A-F]{2})/g,
    function(match, p1) {
      return String.fromCharCode('0x' + p1);
    }
    )
  );
}
export const login_success = (account, password)=>{
  console.log(account, password);
  if(account){
    localStorage.setItem('account', account);
    if(password) localStorage.setItem(token_key, b64EncodeUnicode(`${account}:${password}`));
  }
};
// api请求
export const api_request = (rq) => jy_request(rq, 'api');
export const answer_request = (rq) => jy_request(rq, 'answer');
// auth请求
export const auth_request = (rq) => {
  rq.api_info = {api_prefix: '/auth/'};
  return jy_request(rq, 'auth');
};
// 用户信息相关接口
export const user_request = (rq) => {
  rq.api_info = { api_name: "用户信息", api_prefix: "/api/v2/user/"};
  api_request(rq);
};

export const get_user = (func) => {
  user_request({
    url: '/',  type: 'get',
    success:  func
  })
};
export const put_user = (rq, func) => {
  if(isDEV){
    func({
      data: {},
      status: 1000001
    });
    return;
  }
  user_request({
    url: '/', data: rq, type: 'put',
    success:  func
  })
};
//发送验证码（注册、找回密码、解除绑定）通用
export const get_code = (form, send_code, setFunc, func, is_unbind, errFunc) => {
  const {tel} = form.getFieldsValue();
  if(!tel) {
    jy_tip('请输入手机号');
    return;
  }
  let s = 60;
  let errInfo = {};
  send_code(is_unbind? {tel, 'account': form.getFieldValue('account'), 'password': form.getFieldValue('password')}: tel, function (res) {
    if(res.status === 2) {
      const timer = setInterval(function () {
        s -- ;
        setFunc(`${s}秒后重新获取`);
        if(s <= 0) {
          clearInterval(timer);
          setFunc('重新获取验证码');
        }
      }, 1000)
    }
    else if(res.status === 10801) errInfo = {'tel': {errors: [new Error('今天发送验证码次数已超过限制，请明天重试')]}};
    else if(res.status === 10701) errInfo = {'tel': {errors: [new Error('发送验证码太频繁')]}};
    else if(res.status === 10501) errInfo = {'account': {errors: [new Error('账户名不存在')]}};
    else if(res.status === 10408) errInfo = {'tel': {errors: [new Error('该账户未绑定手机号，无须解除绑定')]}};
    else if(func) func(res);
    else errInfo = {'tel': {errors: [new Error(res.message)]}};
    if(errFunc) errFunc(errInfo);
  });
};
//发送验证码（注册、找回密码、解除绑定）通用
export const get_code_vue = (formValues, send_code, setFunc, func, is_unbind, errFunc) => {
  const {tel, account, password} = formValues;
  if(!tel) {
    jy_tip('请输入手机号');
    return;
  }
  let s = 60;
  let errInfo = {};
  send_code(is_unbind? {tel, account, password}: tel,  (res) => {
    if(res.status === 2) {
      const timer = setInterval(function () {
        s -- ;
        setFunc(`${s}秒后重新获取`);
        if(s <= 0) {
          clearInterval(timer);
          setFunc('重新获取验证码');
        }
      }, 1000)
    }
    else if(res.status === 10801) errInfo = {key: 'tel', msg: '今天发送验证码次数已超过限制，请明天重试'};
    else if(res.status === 10701) errInfo = {key: 'tel', msg: '发送验证码太频繁'};
    else if(res.status === 10501) errInfo = {key: 'account', msg: '账户名不存在'};
    else if(res.status === 10408) errInfo = {key: 'tel', msg: '该账户未绑定手机号，无须解除绑定'};
    else if(func) func(res);
    else errInfo = {key: 'tel', msg: res.message};
    if(errFunc) errFunc(errInfo);
  });
};
export const jy_register = (rq, func) =>{
  //rq: account, password, tel, code
  if(isDEV){
    func({
      data: {...rq},
      status: 1
    });
    return;
  }
  auth_request({
    url: '/', data: rq, type: 'post',
    success: func
  });
};
export const jy_register_code = (tel, func) => {
  auth_request({
    url: '/code/register/', data: {tel, product}, type: 'post',
    success: func
  })
};
// 使用绑定手机号重置密码
export const jy_password_code = (tel, func) => {
  auth_request({
    crud_name: '使用绑定手机号重置密码1-发送验证码',
    url: '/code/password/', data: {tel, product}, type: 'post',
    success: func
  })
};
export const jy_password_reset = (rq, func) => {
  auth_request({
    crud_name: '使用绑定手机号重置密码2-重置密码',
    url: '/password/reset/', data: rq, type: 'put',
    success: func
  })
};
// 解除绑定手机号（发送验证码、解除）
export const jy_unbind_code = (rq, func) => {
  auth_request({
    crud_name: '解除绑定手机号-发送验证码',
    url: '/code/unbind/', data: {...rq, product}, type: 'post',
    success: func
  })
};
export const jy_tel_delete = (rq, func) => {
  auth_request({
    crud_name: '解除绑定手机号',
    url: '/tel/', data: rq, type: 'delete',
    success: func
  })
};
//用户授权A类
export const post_grant_genetic = (account, auth_code, func)=> {
  // if(isDEV){
  //   func({
  //     data: {},
  //     status: 1000002
  //   });
  //   return;
  // }
  api_request({
    type: 'post',
    url: '/api/v2/auth/grant/genetic/',
    data: {account, auth_code},
    crud_name: '对用户授予遗传频道的权限',
    success: func
  });
};


//用户授权B类,仅授予记录个人信息权限,调用获取用户信息API，返回role == 0
export const post_grant_genetic_ordinary = (account, auth_code, func)=> {
  api_request({
    type: 'post',
    url: '/api/v2/auth/grant/ordinary/',
    data: {account, auth_code},
    crud_name: '对用户授予遗传频道的权限',
    success: func
  });
};

//用户注册码
export const jy_code_crud = (rq, method,func)=>{
  jy_request_common({
    data: rq,
    base_url: '/tcm/code/crud/',
    type: method,
    success: func
  })
};
export const get_auth_code = (func)=>{
  jy_request_common({
    type: 'GET',
    base_url: '/tcm/auth/code/',
    url: '',
    success: func
  })
};
